import { render, staticRenderFns } from "./NewPageDialog.vue?vue&type=template&id=74bdf7a1&scoped=true"
import script from "./NewPageDialog.vue?vue&type=script&lang=js"
export * from "./NewPageDialog.vue?vue&type=script&lang=js"
import style0 from "./NewPageDialog.vue?vue&type=style&index=0&id=74bdf7a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bdf7a1",
  null
  
)

export default component.exports